// extracted by mini-css-extract-plugin
module.exports = {"container":"PageSectionLinks-module--container--2wXl_","title":"PageSectionLinks-module--title--3UmFM"};